import { makeStyles } from '@material-ui/core/styles';
import { isDark } from '../../styles';

const useStyles = makeStyles((theme) => ({
  slideContainer: {
    boxShadow: '0px 0px 6px rgba(0,0,0,0.5)',
    borderRadius: 5,
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    maxWidth: 632,
  },
  slideWrap: {
    padding: theme.spacing(2),
    paddingRight: theme.spacing(5),
    paddingLeft: theme.spacing(5),
  },
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    overflow: (p) => (p.isMobile ? 'auto' : 'visible'),
    [theme.breakpoints.up('lg')]: {
      width: '1050px',
      marginLeft: `calc(-25vw + ${theme.spacing(2)}px)`,
      '&> table': {
        minWidth: 350,
        margin: 'auto',
      },
    },
    [theme.breakpoints.up('xl')]: {
      width: '1400px',
      marginLeft: `calc(-350px - ${theme.spacing(1)}px)`,
      '&> table': {
        minWidth: 700,
      },
    },
    position: 'relative',

    '& thead tr': {
      fontWeight: 'bold',
    },

    '& thead.headercells tr': {
      borderBottom: 'none !important',
      borderTop: 'none !important',
      marginLeft: theme.spacing(1),
    },

    '& thead.headercells td': {
      fontWeight: 'bold',
      borderLeft: 'none !important',
      borderRight: 'none !important',

      height: 250,
      whiteSpace: 'nowrap',

      '& > div': {
        transform: 'translate(0px, 107px) rotate(-90deg)',
        width: 40,

        '& > span': {
          padding: '5px 10px',
        },
      },
    },

    '& tbody > tr:nth-child(odd) > td': {},

    '& tr > td:nth-child(1)': {
      fontSize: 14,
      width: 260,
      justifyContent: 'flex-start',

      '& span': {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
      },
    },
    '& td': {
      fontSize: 12,
    },
    '& tbody': {
      position: 'relative',
      top: -2,
      '&> tr > td:nth-child(1)': {
        marginLeft: theme.spacing(1),
      },
    },
  },
  exportButton: {
    display: 'flex',
    position: 'absolute',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2),
    zIndex: 100,
  },
  switch: {
    marginLeft: theme.spacing(1),
  },
  rowAverage: {
    '& tr td:nth-child(2)': {
      borderRight: `1px solid ${isDark(theme) ? 'white' : 'black'}`,
      borderLeft: `1px solid ${isDark(theme) ? 'white' : 'black'}`,
    },
  },
  loadBuffer: {
    padding: theme.spacing(2),
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  rowLink: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: isDark(theme) ? theme.colors.white : 'blue',
  },
  noborder: {
    border: 'none !important',
  },
  notopborder: {
    borderTop: 'none !important',
    marginLeft: theme.spacing(1),
    '&> td': {
      borderBottom: `1px solid ${isDark(theme) ? 'white' : 'black'}`,
    },
  },
  col: {
    width: 40,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  colHasBg: {
    color: theme.colors.black,
  },
  hidePrint: {
    '@media print': {
      display: 'none',
    },
  },
}));

export default useStyles;
